import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromTeams from './+state/teams.reducer'
import { TeamsEffects } from './+state/teams.effects'
import { TeamsFacade } from './+state/teams.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromTeams.TEAMS_FEATURE_KEY, fromTeams.teamsReducer),
    EffectsModule.forFeature([TeamsEffects]),
  ],
  providers: [TeamsFacade],
})
export class GbDashboardTeamDataAccessModule {}
